export default __webpack_public_path__ + "static/media/vans-M.b5b26c4d.png";